import update from 'immutability-helper';
import createReducer from '../../../../../common/utils/createReducer.js';
import { types } from '../actions/actionTypes.js';

const initialState = {
  config: {
    widgetList: []
  },
  isConfigLoading: false,
  isFetchingData: false
};

const reducer = {

  [types.SET_ROOM_RANKER_CONFIG]: (state, action) => {
    return update(state, {
      config: {
        widgetList: { $set: action.payload }
      }
    });
  },

  [types.SAVE_ROOM_RANKER_TABLE_DATA]: (state, action) => {
    const { widgetId, tableData, totalRecords } = action.payload;

    return update(state, {
      config: {
        $apply: config => ({
          ...config,
          [widgetId]: {
            ...(config?.[widgetId] || {}),
            tableData,
            totalRecords
          }
        })
      }
    });
  },


  [types.SET_ROOM_RANKER_CONFIG_LOADING]: (state, action) => {
    return update(state, {
      isConfigLoading: { $set: action.payload.loading }
    });
  },
  [types.SET_ROOM_RANKER_DATA_LOADING]: (state, action) => {
    return update(state, {
      isFetchingData: { $set: action.payload.loading }
    });
  }
};

export default createReducer(initialState, reducer);
